const AutocopmleteWizardSearch = {
	en: {
		placeholderInput: "choose insurance",
		placeholderCarrier: "insurance carrier and plan",
		placeholderPlan: "insurance plan",
		navChooseCarrier: 'Step 1: Choose carrier',
		navChoosePlan: 'Step 2: Choose plan',
		chooseDiferent: 'Choose a different insurance'
	},
	es: {
		placeholderInput: "elige seguro",
		placeholderCarrier: "compañía de seguros y plan",
		placeholderPlan: "plan de seguro",
		navChooseCarrier: 'Paso 1: Elegir operador',
		navChoosePlan: 'Paso 2: Elige un plan',
		chooseDiferent: 'Elija un seguro diferente'
	},
	ko: {
		placeholderInput: "chwazi asirans",
		placeholderCarrier: "asirans konpayi asirans ak plan",
		placeholderPlan: "asirans plan",
		navChooseCarrier: 'Etap 1: Chwazi konpayi asirans lan',
		navChoosePlan: 'Etap 2: Chwazi plan',
		chooseDiferent: 'Chwazi yon asirans diferan'
	}
};
export default AutocopmleteWizardSearch;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/autocomplete-wizard-search/autocopmlete-wizard-search.language.js